import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "cross-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.16412 5.10349C5.87123 4.8106 5.39636 4.8106 5.10346 5.10349C4.81057 5.39638 4.81057 5.87126 5.10346 6.16415L10.9355 11.9962L5.10346 17.8283C4.81057 18.1212 4.81057 18.5961 5.10346 18.889C5.39635 19.1819 5.87123 19.1819 6.16412 18.889L11.9962 13.0569L17.8283 18.889C18.1212 19.1818 18.596 19.1818 18.8889 18.889C19.1818 18.5961 19.1818 18.1212 18.8889 17.8283L13.0569 11.9962L18.8889 6.16416C19.1818 5.87127 19.1818 5.39639 18.8889 5.1035C18.596 4.81061 18.1212 4.8106 17.8283 5.1035L11.9962 10.9356L6.16412 5.10349Z" }, null, -1)
  ])))
}
export default { render: render }